import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';
import type { TextInputSize } from '@opendoor/tokens-studio/dist/bricks-next/types/Components';
import { isWeb, styled, View } from '@tamagui/core';

import { isKeyOfObject } from '../../../helpers/utils';
import type { InputState } from './InputProps';

const { textInput: textInputTokens } = tokens;

/**
 * Container component shared by different kinds of input components
 */
export const InputFrame = styled(View, {
  backgroundColor: textInputTokens.color.background.default,

  flexDirection: 'row',
  gap: textInputTokens.padding.gap.textAndIcon.default,
  animation: 'linear',
  animateOnly: isWeb
    ? [
        'border-color',
        'border-top-color',
        'border-left-color',
        'border-bottom-color',
        'border-right-color',
      ]
    : ['borderColor', 'borderTopColor', 'borderLeftColor', 'borderBottomColor', 'borderRightColor'],

  variants: {
    size: (size: TextInputSize) => {
      return {
        borderRadius: textInputTokens.cornerRadius[size],
        paddingVertical: textInputTokens.padding.topBottom[size],
        paddingHorizontal: textInputTokens.padding.leftRight[size],
        height:
          size in textInputTokens.size.height
            ? textInputTokens.size.height[size as keyof typeof textInputTokens.size.height]
            : undefined,
      };
    },

    state: (state: InputState) => {
      const backgroundColor = isKeyOfObject(state, textInputTokens.color.background.state)
        ? textInputTokens.color.background.state[state]
        : textInputTokens.color.background.default;

      const borderColor = state
        ? textInputTokens.color.border.state[state]
        : textInputTokens.color.border.default;

      const borderWidth = textInputTokens.borderWidth.default;

      const hoverStyle = state ? {} : { borderColor: textInputTokens.color.border.state.hover };

      const cursor = state === 'inactive' ? 'default' : 'text';

      return {
        backgroundColor,
        borderColor,
        borderWidth,
        hoverStyle,
        cursor,
      };
    },
  } as const,
});
